import React, { useEffect, useState, memo } from "react";
import { Link } from "react-router-dom";

const EmployeeHome = memo(function EmployeeHome() {
  const [companyData, setCompanyData] = useState(null);

  useEffect(() => {
    // Load existing data first
    const storedData = JSON.parse(localStorage.getItem("companyData"));
    setCompanyData(storedData);
    console.log("[EmployeeHome] Loaded company data:", storedData);

    // 🆕 Listen for company data updates (from SuperAdmin)
    const handleCompanyUpdate = (e) => {
      console.log("[EmployeeHome] 🔄 Company updated via event:", e.detail);
      setCompanyData(e.detail);
    };

    window.addEventListener("companyDataUpdated", handleCompanyUpdate);
    return () =>
      window.removeEventListener("companyDataUpdated", handleCompanyUpdate);
  }, []);

  return (
    <div className="p-6">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Always visible */}
        <Link
          to="/employee/profile"
          className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
        >
          <h2 className="text-xl font-semibold mb-2">Profile</h2>
          <p>View and edit your profile information</p>
        </Link>

        {/* ✅ Only show Payroll if enabled */}
        {companyData?.module_payroll === 1 && (
          <Link
            to="/employee/payroll"
            className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <h2 className="text-xl font-semibold mb-2">Payroll</h2>
            <p>Access your salary information and payslips</p>
          </Link>
        )}

        {/* ✅ Only show Attendance if enabled */}
        {companyData?.module_attendance === 1 && (
          <Link
            to="/employee/attendance"
            className="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow"
          >
            <h2 className="text-xl font-semibold mb-2">Attendance</h2>
            <p>Check your attendance records</p>
          </Link>
        )}
      </div>
    </div>
  );
});

export default EmployeeHome;
